"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const o=1e3,s=e=>e*o;exports.secondsToMs=s;
